<!-- Security -->
<div
    *ngIf="selectedAccount?.isMfaEnabled || hasMfaAuths"
    #section
    id="security"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading first"> {{ 'UserPreferences.general.security' | localize }}</h4>
    <div class="agpr-userPreferences-subSection-content">
        <agpr-mfa-management [addNewMethod]="true"></agpr-mfa-management>
    </div>
</div>
<!-- Time Zone -->
<div #section id="timeZone" class="agpr-userPreferences-subSection">
    <h4 class="agpr-userPreferences-subSection-heading"> {{ 'UserPreferences.general.timeZone' | localize }}</h4>
    <div class="agpr-userPreferences-subSection-content">
        <agpr-timezone-picker
            class='agpr-userPreferences-timeZoneDropdown'
            [ngModel]="generalPreferences?.timeZone"
            (ngModelChange)="timeZoneChanged($event)"
        ></agpr-timezone-picker>
    </div>
</div>
<!-- Date / Time Formats -->
<div #section id="dateTimeFormat" class="agpr-userPreferences-subSection">
    <h4 class="agpr-userPreferences-subSection-heading"> {{ 'UserPreferences.general.dateTimeFormat' | localize }}</h4>
    <div class="agpr-userPreferences-subSection-content">
        <div class="agpr-userPreferences-subSection-dateTime">
            <agpr-dropdown
                [id]="'userPreferences_dateFormatDropdown'"
                label="UserPreferences.general.date"
                [options]="dateFormatOptions"
                [(ngModel)]="selectedDateFormat"
                (ngModelChange)="dateFormatChanged($event)"
            ></agpr-dropdown>
            <div class="agpr-userPreferences-subSection-dateTime-time">
                <span>{{'UserPreferences.general.time' | localize}}</span>
                <agpr-checkbox
                    [id]="'userPreferences_24HourTime'"
                    label="UserPreferences.general.time.24hour"
                    [(ngModel)]="twentyFourHourTimeSelected"
                    [binary]="true"
                    (ngModelChange)="timeFormatChanged($event)"
                ></agpr-checkbox>
            </div>
        </div>
    </div>
</div>
<!-- Languages -->
<div #section id="languages" class="agpr-userPreferences-subSection">
    <h4 class="agpr-userPreferences-subSection-heading"> {{ 'UserPreferences.general.languages' | localize }} </h4>
    <div class="agpr-userPreferences-subSection-content agpr-userPreferences-subSection-contentGrid">
        <div class="agpr-userPreferences-subSection-languageWrapper">
            <agpr-dropdown
                [id]="'userPreferences_languageDropdown'"
                placeholder="Mention.editDialog.language.placeholder"
                [options]="uiLanguageOptions"
                [(ngModel)]="selectedUiLanguage"
                (ngModelChange)="uiLanguageChanged($event)"
                label="UserPreferences.general.languages.ui"
            ></agpr-dropdown>
        </div>

        <div class="agpr-userPreferences-subSection-refDatalanguageWrapper">
            <agpr-dropdown
                [id]="'userPreferences_refDatalanguageDropdown'"
                placeholder="Mention.editDialog.language.placeholder"
                [options]="referenceDataLanguageOptions"
                [(ngModel)]="selectedReferenceDataLanguage"
                (ngModelChange)="referenceDataLanguageChanged($event)"
                label="UserPreferences.general.languages.referenceData"
            ></agpr-dropdown>
        </div>
    </div>
</div>
<!-- Currency -->
<div #section id="currency" class="agpr-userPreferences-subSection">
    <h4
        [id]="'generalPreferences_currencyAutocompleteLabel'"
        class="agpr-userPreferences-subSection-heading"
    >
        {{ 'UserPreferences.general.currency' | localize }}
    </h4>
    <div class="agpr-userPreferences-subSection-content agpr-userPreferences-subSection-contentGrid">
        <agpr-autocomplete
            [id]="'userPreferences_currencyAutocompelete'"
            [suggestions]="suggestions$"
            labelField="label"
            ariaLabelledBy="generalPreferences_currencyAutocompleteLabel"
            [dropdown]="true"
            [(ngModel)]="selectedCurrencyOption"
            [clearOnBlur]="false"
            (itemSelected)="selectCurrency($event)"
            [minLength]="1"
        ></agpr-autocomplete>
    </div>
</div>
<!-- Accessibility -->
<div #section id="accessibility" class="agpr-userPreferences-subSection">
    <h4
        [id]="'generalPreferences_accessibility'"
        class="agpr-userPreferences-subSection-heading"
    >
        {{ 'UserPreferences.general.accessibility' | localize }}
    </h4>
    <div class="agpr-userPreferences-subSection-accessibility">
        <agpr-checkbox
            [id]="'generalPreferences_accessibility_toolbars'"
            label="UserPreferences.general.accessibility.toolbars"
            [binary]="true"
            [(ngModel)]="collapseToolbars"
            (ngModelChange)="onAccessibilityChanged()"
        ></agpr-checkbox>
        <agpr-checkbox
            [id]="'generalPreferences_accessibility_tooltip'"
            label="UserPreferences.general.accessibility.tooltips"
            [binary]="true"
            [(ngModel)]="tooltipsOnFocus"
            (ngModelChange)="onAccessibilityChanged()"
        ></agpr-checkbox>
    </div>
</div>
<!-- Favorite Colors -->
<div #section #favoriteColorsSection [id]="favoriteColorId" class="agpr-userPreferences-subSection">
    <agpr-favorite-colors-preferences
        [favoriteColors]="favoriteColors"
        (colorsChanged)="onfavoriteColorsChanged($event)"
        >
        <h4 id="generalPreferences_favoriteColors"
            class="agpr-userPreferences-subSection-heading">
            {{ 'UserPreferences.general.favoriteColors' | localize }}
        </h4>
    </agpr-favorite-colors-preferences>
</div>
<!-- Notification -->
<div #section id="notification" class="agpr-userPreferences-subSection">
    <h4
        [id]="'generalPreferences_notificationLabel'"
        class="agpr-userPreferences-subSection-heading"
    >
        {{ 'UserPreferences.general.notification' | localize }}
    </h4>
    <div class="agpr-userPreferences-subSection-content">
        @if (hasTargeting) {
            <div class="agpr-userPreferences-subSection-groupWrapper">
                <h5
                    [id]="'generalPreferences_notification_discoverHeader'"
                    class="agpr-userPreferences-subSection-groupHeader"
                >
                    {{ 'UserPreferences.general.notification.discover' | localize }}
                </h5>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_distributionQuotaUsageWarnings_checkbox'"
                    label="UserPreferences.general.notification.distributionQuotaUsageWarnings"
                    [binary]="true"
                    [(ngModel)]="generalPreferences.notificationPreference.distributionQuotaUsageWarnings"
                    (ngModelChange)="checkDirty.emit()"
                ></agpr-checkbox>
            </div>
        }
        @if (hasMonitoring) {
            <div class="agpr-userPreferences-subSection-groupWrapper">
                <h5
                    [id]="'generalPreferences_notification_monitorHeader'"
                    class="agpr-userPreferences-subSection-groupHeader"
                >
                    {{ 'UserPreferences.general.notification.monitor' | localize }}
                </h5>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_alertExpirationWarnings_checkbox'"
                    label="UserPreferences.general.notification.alertExpirationWarnings"
                    [binary]="true"
                    [(ngModel)]="alertExpirationWarnings"
                    (ngModelChange)="notificationChanged()"
                ></agpr-checkbox>
                <div
                    class="agpr-generalPreferences-content-radioGroup"
                    *ngIf="alertExpirationWarnings"
                >
                    <agpr-radio
                        [id]="'generalPreferences_notification_alertExpirationWarnings_allRadio'"
                        [(ngModel)]="selectedAlertExpirationWarnings"
                        label="UserPreferences.general.notification.all"
                        [value]="notificationPreferenceTypes.ALL"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.all"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="'generalPreferences_notification_alertExpirationWarnings_createdByMeRadio'"
                        label="UserPreferences.general.notification.alertExpirationWarnings.createdByMe"
                        [(ngModel)]="selectedAlertExpirationWarnings"
                        [value]="notificationPreferenceTypes.CREATED_BY_ME"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.alertExpirationWarnings.createdByMe"
                    ></agpr-radio>
                </div>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_mentionQuotaWarnings_checkbox'"
                    label="UserPreferences.general.notification.mentionQuotaWarnings"
                    [binary]="true"
                    [(ngModel)]="generalPreferences.notificationPreference.mentionQuotaWarnings"
                    (ngModelChange)="checkDirty.emit()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_topicModerationWarnings_checkbox'"
                    label="UserPreferences.general.notification.topicModerationWarnings"
                    [binary]="true"
                    [(ngModel)]="topicModerationWarnings"
                    (ngModelChange)="notificationChanged()"
                ></agpr-checkbox>
                <div
                    class="agpr-generalPreferences-content-radioGroup"
                    *ngIf="topicModerationWarnings"
                >
                    <agpr-radio
                        [id]="'generalPreferences_notification_topicModerationWarnings_allRadio'"
                        [(ngModel)]="selectedTopicModerationWarnings"
                        label="UserPreferences.general.notification.all"
                        [value]="notificationPreferenceTypes.ALL"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.all"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="'generalPreferences_notification_topicModerationWarnings_createdByMeRadio'"
                        label="UserPreferences.general.notification.topicModerationWarnings.createdByMe"
                        [(ngModel)]="selectedTopicModerationWarnings"
                        [value]="notificationPreferenceTypes.CREATED_BY_ME"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.topicModerationWarnings.createdByMe"
                    ></agpr-radio>
                </div>
            </div>
        }
        @if (hasAutomationAgents) {
            <div class="agpr-userPreferences-subSection-groupWrapper">
                <h5
                    [id]="'generalPreferences_notification_automationAgentsHeader'"
                    class="agpr-userPreferences-subSection-groupHeader"
                >
                    {{ 'UserPreferences.general.notification.automationAgents' | localize }}
                </h5>
                <!-- Held by agents-service rather than the preferences record, so it is written on
                     save through its own endpoint -->
                <agpr-checkbox
                    [id]="'generalPreferences_notification_automationAgentQuotaWarnings_checkbox'"
                    label="UserPreferences.general.notification.automationAgentQuotaWarnings"
                    [binary]="true"
                    [(ngModel)]="automationAgentQuotaWarnings"
                    (ngModelChange)="checkDirty.emit()"
                ></agpr-checkbox>
            </div>
        }
        @if (hasSocial) {
            <div class="agpr-userPreferences-subSection-groupWrapper">
                <h5
                    [id]="'generalPreferences_notification_monitorHeader'"
                    class="agpr-userPreferences-subSection-groupHeader"
                >
                    {{ 'UserPreferences.general.notification.social' | localize }}
                </h5>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_socialQuotaUsageWarnings_checkbox'"
                    label="UserPreferences.general.notification.socialQuotaUsageWarnings"
                    [binary]="true"
                    [(ngModel)]="generalPreferences.notificationPreference.socialQuotaUsageWarnings"
                    (ngModelChange)="checkDirty.emit()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_socialModerationWarnings_checkbox'"
                    label="UserPreferences.general.notification.socialModerationWarnings"
                    [binary]="true"
                    [(ngModel)]="socialModerationWarnings"
                    (ngModelChange)="notificationChanged()"
                ></agpr-checkbox>
                <div
                    class="agpr-generalPreferences-content-radioGroup"
                    *ngIf="socialModerationWarnings"
                >
                    <agpr-radio
                        [id]="'generalPreferences_notification_socialModerationWarnings_allRadio'"
                        [(ngModel)]="selectedSocialModerationWarnings"
                        label="UserPreferences.general.notification.all"
                        [value]="notificationPreferenceTypes.ALL"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.all"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="'generalPreferences_notification_socialModerationWarnings_createdByMeRadio'"
                        label="UserPreferences.general.notification.socialModerationWarnings.createdByMe"
                        [(ngModel)]="selectedSocialModerationWarnings"
                        [value]="notificationPreferenceTypes.CREATED_BY_ME"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.socialModerationWarnings.createdByMe"
                    ></agpr-radio>
                </div>
            </div>
        }
        @if (hasMonitoring) {
            <div class="agpr-userPreferences-subSection-groupWrapper">
                <h5
                    [id]="'generalPreferences_notification_monitorHeader'"
                    class="agpr-userPreferences-subSection-groupHeader"
                >
                    {{ 'UserPreferences.general.notification.subscription' | localize }}
                </h5>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_subscriptionQuotaUsageWarnings_checkbox'"
                    label="UserPreferences.general.notification.subscriptionQuotaUsageWarnings"
                    [binary]="true"
                    [(ngModel)]="generalPreferences.notificationPreference.subscriptionQuotaUsageWarnings"
                    (ngModelChange)="checkDirty.emit()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'generalPreferences_notification_subscriptionModerationWarnings_checkbox'"
                    label="UserPreferences.general.notification.subscriptionModerationWarnings"
                    [binary]="true"
                    [(ngModel)]="subscriptionModerationWarnings"
                    (ngModelChange)="notificationChanged()"
                ></agpr-checkbox>
                <div
                    class="agpr-generalPreferences-content-radioGroup"
                    *ngIf="subscriptionModerationWarnings"
                >
                    <agpr-radio
                        [id]="'generalPreferences_notification_subscriptionModerationWarnings_allRadio'"
                        [(ngModel)]="selectedSubscriptionModerationWarnings"
                        label="UserPreferences.general.notification.all"
                        [value]="notificationPreferenceTypes.ALL"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.all"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="'generalPreferences_notification_subscriptionModerationWarnings_createdByMeRadio'"
                        label="UserPreferences.general.notification.subscriptionModerationWarnings.createdByMe"
                        [(ngModel)]="selectedSubscriptionModerationWarnings"
                        [value]="notificationPreferenceTypes.CREATED_BY_ME"
                        (ngModelChange)="notificationChanged()"
                        hiddenLabel="UserPreferences.general.notification.subscriptionModerationWarnings.createdByMe"
                    ></agpr-radio>
                </div>
            </div>
        }



    </div>
</div>
